// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"47bdf1a0","296":"026ef9e1","428":"aaf41c93","483":"d3a29ef1","693":"f23012f6","777":"00649d14","782":"cb550648","805":"6a0d807c","874":"45913df6"}[chunkId] + ".chunk.js";
};